import React, { useState } from "react";
import SbEditable from "storyblok-react"
import RichText from "src/utils/RichText";
import Label from "src/components/Label";
import Heading from "src/components/Heading";
import GetSettings from "src/utils/GetSettings";
import Tab from "./Tab"
import Panel from "./Panel"

const SplitWithImagesSlider = ({blok}) => {
    const settings = GetSettings()
    const [active, setActive] = useState('connect')
    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className={`relative bg-white`}>
                <div className={`relative max-w-7xl mx-auto px-6 lg:my-40 my-28`}>
                    <div>
                        <Label className={`text-lightblue-300 text-center`} p={true}>{blok.label}</Label>
                        <Heading size="h2" className="text-darkblue mt-6 font-semibold text-center brightgreenBold">
                            <RichText>{blok.title}</RichText>
                        </Heading>
                    </div>
                    <div className="lg:my-12 my-8 border-2 rounded-full w-fit shadow-lg  flex md:justify-center justify-self-center  justify-between items-center">
                        <Tab id="connect" active={active} setActive={setActive}/>
                        <Tab id="protect" active={active} setActive={setActive}/>
                        <Tab id="inspect" active={active} setActive={setActive}/>
                    </div>
                    <p className="font-semibold text-3xl text-[#002432] flex justify-self-center mb-8">
                          {active.charAt(0).toUpperCase() + active.slice(1)}
                    </p>
                    <div>
                        <Panel 
                            id="connect" 
                            active={active} 
                            description={settings.connect_description} 
                            target={settings.connect_target}
                            image={settings.connect_image}
                        />
                        <Panel 
                            id="protect" 
                            active={active} 
                            description={settings.protect_description} 
                            target={settings.protect_target}
                            image={settings.protect_image}
                        />
                        <Panel 
                            id="inspect" 
                            active={active} 
                            description={settings.inspect_description} 
                            target={settings.inspect_target}
                            image={settings.inspect_image}
                        />
                    </div>
                </div>
            </div>
        </SbEditable>
    );
};

export default SplitWithImagesSlider;
